/* lettra: Warenkorb-Drawer — Gratis-Versand-Fortschritt, Produktvorschlag,
   Rabattcode (snippets/cart-drawer.liquid).

   ARBEITSTEILUNG MIT LIQUID: Alle Zustaende (Balkenbreite, Fehlbetrag,
   Sichtbarkeit des Vorschlags, angewendeter Code) rechnet der Server —
   jede Mengenaenderung (cart.js), jedes Hinzufuegen
   (cart-drawer.js/renderContents) und jede Rabattanwendung (hier)
   rendert .drawer__inner neu aus Liquid. Dieses Skript stoesst nur an
   und ueberbrueckt:
   1. Balken-Animation: Beim innerHTML-Tausch entsteht ein neues
      Element, das ohne Zutun auf die neue Breite SPRINGT. Hier wird die
      alte Breite gemerkt und der Uebergang animiert (160ms).
   2. Klicks auf Vorschlag-Button und Rabatt-Bedienung.

   WARUM DELEGATION UND OBSERVER STATT DIREKTER BINDUNG: Die Drawer-
   Fragmente werden per innerHTML ersetzt (Werkzeugfalle, siehe
   docs/WERKZEUGFALLEN.md) — direkte Listener und Skripte im Fragment
   ueberleben das nicht. Klicks laufen deshalb ueber document, das
   Nachfassen ueber einen MutationObserver, dasselbe Muster wie
   assets/lettra-cart-preview.js. Bewusst NICHT an PUB_SUB_EVENTS
   .cartUpdate gehaengt: renderContents (der Hinzufuegen-Pfad, den
   genau der Vorschlag-Button ausloest) feuert das Event nicht. */
(function () {
  'use strict';

  var FEHLER_CODE = 'Code ungültig oder nicht auf diesen Warenkorb anwendbar.';
  var FEHLER_NETZ = 'Keine Verbindung. Prüfe deine Internetverbindung und versuch es noch einmal.';

  /* ---------- Fortschrittsbalken: nur der Uebergang ---------- */

  var letzterProzent = null;

  function fortschrittAnimieren() {
    var kasten = document.querySelector('[data-lettra-versandziel]');
    if (!kasten) {
      /* Korb geleert: Merkwert zuruecksetzen, damit der naechste
         Balken wieder von vorn beginnt statt von einem alten Stand. */
      letzterProzent = null;
      return;
    }
    if (kasten.__animiert) return;
    kasten.__animiert = true;

    var schwelle = parseInt(kasten.getAttribute('data-schwelle'), 10);
    var total = parseInt(kasten.getAttribute('data-total'), 10);
    var fuellung = kasten.querySelector('.lettra-versandziel__fuellung');
    if (!fuellung || !(schwelle > 0) || !(total >= 0)) return;

    var ziel = Math.min(100, (total / schwelle) * 100);
    if (letzterProzent !== null && Math.abs(letzterProzent - ziel) > 0.1) {
      /* Neues Element auf den alten Stand setzen, Reflow erzwingen,
         dann zum Ziel — die width-Transition (160ms) liegt im CSS. */
      fuellung.style.transition = 'none';
      fuellung.style.width = letzterProzent + '%';
      void fuellung.offsetWidth;
      fuellung.style.transition = '';
      fuellung.style.width = ziel + '%';
    }
    letzterProzent = ziel;
  }

  /* ---------- Einklappbare Positionsdetails (Schriftzug) ----------
     Der Auf/Zu-Zustand lebt hier pro item.key — der Drawer wird bei
     jeder Mengenaenderung komplett neu aus Liquid gerendert, ein
     Zustand im DOM wuerde das nicht ueberleben. Bewusst KEIN
     localStorage/sessionStorage (im Theme nicht erwuenscht): Die
     Merkliste gilt fuer die Seitensitzung, das reicht. */

  var offeneDetails = {};

  function detailsSetzen(wurzel, offen, sofort) {
    var panel = wurzel.querySelector('.lettra-posdetails__panel');
    if (sofort && panel) {
      /* Wiederherstellen nach Re-Render: Zustand ohne Animation
         setzen, sonst klappt jede offene Position sichtbar neu auf. */
      panel.style.transition = 'none';
    }
    wurzel.classList.toggle('is-offen', offen);
    var toggle = wurzel.querySelector('[data-lettra-posdetails-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (sofort && panel) {
      void panel.offsetHeight;
      panel.style.transition = '';
    }
  }

  function detailsWiederherstellen() {
    var kaesten = document.querySelectorAll('[data-lettra-posdetails]:not([data-lettra-restauriert])');
    for (var i = 0; i < kaesten.length; i++) {
      var kasten = kaesten[i];
      kasten.setAttribute('data-lettra-restauriert', '1');
      var key = kasten.getAttribute('data-lettra-pos-key');
      if (key && offeneDetails[key]) detailsSetzen(kasten, true, true);
    }
  }

  function nachRender() {
    fortschrittAnimieren();
    detailsWiederherstellen();
  }

  if (window.MutationObserver) {
    var warte = null;
    new MutationObserver(function () {
      clearTimeout(warte);
      warte = setTimeout(nachRender, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nachRender);
  } else {
    nachRender();
  }

  /* ---------- Drawer neu laden (nach Rabattanwendung) ----------
     Mengenaenderung und Hinzufuegen bringen ihre Sections selbst mit
     (cart.js bzw. renderContents); nur die Rabattwege muessen den
     Drawer selbst nachladen. Getauscht wird .drawer__inner — Overlay
     und dessen Close-Listener liegen ausserhalb und bleiben stehen. */

  function drawerNeuLaden() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var neu = html.querySelector('.drawer__inner');
        var drawer = document.querySelector('cart-drawer');
        var alt = drawer ? drawer.querySelector('.drawer__inner') : null;
        if (!neu || !alt) return;
        alt.innerHTML = neu.innerHTML;
        /* Vorschau-Einpassung und Balken-Animation stossen sich ueber
           ihre eigenen Observer an. Fokus zurueck in den Drawer — das
           geklickte Element existiert nicht mehr. */
        alt.focus();
      });
  }

  /* ---------- Produktvorschlag ---------- */

  function vorschlagFehler(wurzel, text) {
    var fehler = wurzel ? wurzel.querySelector('[data-lettra-vorschlag-fehler]') : null;
    if (!fehler) return;
    fehler.textContent = text || '';
    fehler.hidden = !text;
  }

  function vorschlagHinzufuegen(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    var wurzel = btn.closest('[data-lettra-vorschlag]');
    vorschlagFehler(wurzel, '');

    var formData = new FormData();
    formData.append('id', btn.getAttribute('data-variant-id'));
    formData.append('quantity', 1);
    /* Dieselben Properties in derselben Reihenfolge wie die
       Produktseite (assets/lettra-nfc.js, addToCart) — die Korbzeile
       zeigt fuer dieses Produkt die Properties statt der
       Optionszeile. */
    formData.append('properties[Farbe]', btn.getAttribute('data-farbe'));
    formData.append('properties[Daten auf dem Chip]', btn.getAttribute('data-chip'));

    var cart = document.querySelector('cart-drawer');
    if (cart && cart.getSectionsToRender) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          btn.disabled = false;
          vorschlagFehler(wurzel, data.description || data.message || FEHLER_NETZ);
          return;
        }
        if (cart && cart.renderContents) {
          /* renderContents tauscht #CartDrawer komplett — Fortschritt
             und Vorschlag kommen serverseitig neu, der Drawer bleibt
             offen. */
          cart.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        vorschlagFehler(wurzel, FEHLER_NETZ);
      });
  }

  /* ---------- Rabattcode ---------- */

  function rabattFehler(wurzel, text) {
    var fehler = wurzel ? wurzel.querySelector('[data-lettra-rabatt-fehler]') : null;
    if (!fehler) return;
    fehler.textContent = text || '';
    fehler.hidden = !text;
  }

  function rabattUmschalten(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var offen = panel.classList.toggle('is-offen');
    toggle.setAttribute('aria-expanded', offen ? 'true' : 'false');
    if (offen) {
      var feld = panel.querySelector('[data-lettra-rabatt-feld]');
      /* Fokus erst nach der Aufklapp-Transition — vorher scrollte der
         Browser ein noch unsichtbares Feld an. */
      if (feld) setTimeout(function () { feld.focus(); }, 160);
    }
  }

  function rabattAnwenden(btn) {
    if (btn.disabled) return;
    var wurzel = btn.closest('[data-lettra-rabatt]');
    var feld = wurzel ? wurzel.querySelector('[data-lettra-rabatt-feld]') : null;
    var code = feld ? feld.value.trim() : '';
    if (!code) {
      if (feld) feld.focus();
      return;
    }
    btn.disabled = true;
    rabattFehler(wurzel, '');

    /* /discount/CODE setzt den Code am Warenkorb und liefert ueber den
       redirect den Warenkorb als JSON zurueck. Erfolg ist NUR
       applicable == true — ungueltige Codes stehen ebenfalls in
       discount_codes, mit applicable == false (gemessen 1. 9.). Ein
       nicht anwendbarer Code bleibt am Korb haengen, ist aber
       wirkungslos; steigt der Korbwert spaeter ueber seinen
       Mindestbetrag, wendet Shopify ihn an und der naechste Render
       zeigt ihn als aktive Zeile — gewollt. */
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var codes = data.discount_codes || [];
        var angewendet = codes.some(function (c) {
          return c.applicable && c.code && c.code.toUpperCase() === code.toUpperCase();
        });
        if (angewendet) {
          /* Neu rendern: Liquid zeigt die aktive Code-Zeile und rechnet
             den Fortschritt neu — der Rabatt senkt cart.total_price,
             der Kunde kann dadurch unter die Schwelle rutschen. */
          return drawerNeuLaden();
        }
        btn.disabled = false;
        rabattFehler(wurzel, FEHLER_CODE);
      })
      .catch(function () {
        btn.disabled = false;
        rabattFehler(wurzel, FEHLER_NETZ);
      });
  }

  function rabattEntfernen(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return drawerNeuLaden(); })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------- Delegation ---------- */

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var posToggle = event.target.closest('[data-lettra-posdetails-toggle]');
    if (posToggle) {
      var kasten = posToggle.closest('[data-lettra-posdetails]');
      if (kasten) {
        var offen = !kasten.classList.contains('is-offen');
        detailsSetzen(kasten, offen, false);
        var key = kasten.getAttribute('data-lettra-pos-key');
        if (key) {
          if (offen) {
            offeneDetails[key] = true;
          } else {
            delete offeneDetails[key];
          }
        }
      }
      return;
    }
    var add = event.target.closest('[data-lettra-vorschlag-add]');
    if (add) { vorschlagHinzufuegen(add); return; }
    var toggle = event.target.closest('[data-lettra-rabatt-toggle]');
    if (toggle) { rabattUmschalten(toggle); return; }
    var anwenden = event.target.closest('[data-lettra-rabatt-anwenden]');
    if (anwenden) { rabattAnwenden(anwenden); return; }
    var entfernen = event.target.closest('[data-lettra-rabatt-entfernen]');
    if (entfernen) { rabattEntfernen(entfernen); }
  });

  document.addEventListener('keydown', function (event) {
    /* keyCode/code als Fallback: manche synthetischen Events (und
       IME-Faelle) tragen kein event.key. */
    if (event.key !== 'Enter' && event.code !== 'Enter' && event.keyCode !== 13) return;
    if (!event.target || !event.target.closest) return;
    var feld = event.target.closest('[data-lettra-rabatt-feld]');
    if (!feld) return;
    event.preventDefault();
    var wurzel = feld.closest('[data-lettra-rabatt]');
    var btn = wurzel ? wurzel.querySelector('[data-lettra-rabatt-anwenden]') : null;
    if (btn) rabattAnwenden(btn);
  });

  /* Tippen loescht den Inline-Fehler des Felds — gleiche Konvention
     wie bei den Notfalldaten-Feldern (assets/lettra-nfc.js). */
  document.addEventListener('input', function (event) {
    if (!event.target || !event.target.closest) return;
    var feld = event.target.closest('[data-lettra-rabatt-feld]');
    if (!feld) return;
    rabattFehler(feld.closest('[data-lettra-rabatt]'), '');
  });
})();
